// import { useState, useEffect } from "react";
// import { Container, Row, Col } from "react-bootstrap";
// import { ArrowRightCircle } from "react-bootstrap-icons";
// import headerImg from "../assets/img/header-img.svg";
// import 'animate.css';
// import TrackVisibility from 'react-on-screen';

// export const Banner = () => {
//     const [loopNum, setLoopNum] = useState(0);
//     const [isDeleting, setIsDeleting] = useState(false);
//     const toRotate = ["MERN Stack Developer", "DevOps Engineer", "Software Engineer"];
//     const [text, setText] = useState('');
//     const [delta, setDelta] = useState(300 - Math.random() * 100);
//     const period = 2000; // Pause duration when full word is typed

//     useEffect(() => {
//         const ticker = setInterval(() => {
//             tick();
//         }, delta);

//         return () => clearInterval(ticker);
//     }, [text]);

//     const tick = () => {
//         const i = loopNum % toRotate.length;
//         const fullText = toRotate[i];
//         const updatedText = isDeleting
//             ? fullText.substring(0, text.length - 1)
//             : fullText.substring(0, text.length + 1);

//         setText(updatedText);

//         if (isDeleting) {
//             setDelta(prevDelta => prevDelta / 2);
//         }

//         if (!isDeleting && updatedText === fullText) {
//             setIsDeleting(true);
//             setDelta(period); // Pause before deleting
//         } else if (isDeleting && updatedText === '') {
//             setIsDeleting(false);
//             setLoopNum(prevLoopNum => prevLoopNum + 1);
//             setDelta(500); // Pause before typing next word
//         }
//     };

//     return (
//         <section className="banner" id="home">
//             <Container>
//                 <Row className="align-items-center">
//                     <Col xs={12} md={6} xl={7}>
//                       <TrackVisibility>
//                          {({ isVisible }) =>
//                             <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
//                                 <span className="tagline">Welcome To My Portfolio</span>
//                                 <h1>
//                                 {`Hi my name is Dennis and I am a `}
//                                 <span className="wrap">{text}</span>
//                                 </h1>

//                                 {/* Let's Connect Button */}
//                                 <button onClick={() => console.log('connect')}>
//                                 Let's Connect <ArrowRightCircle size={25} />
//                                 </button>

                               
//                             </div>
//         }

//                         </TrackVisibility>
//                     </Col>
//                     <Col xs={12} md={6} xl={5}>
//                         <img src={headerImg} alt="Header Img" />
//                     </Col>
//                 </Row>
//             </Container>
//         </section>
//     );
// };

import { useState, useEffect, useCallback } from "react";
import { Container, Row, Col } from "react-bootstrap";
import { ArrowRightCircle } from "react-bootstrap-icons";
import headerImg from "../assets/img/header-img.svg";
import 'animate.css';
import TrackVisibility from 'react-on-screen';

export const Banner = () => {
    const [loopNum, setLoopNum] = useState(0);
    const [isDeleting, setIsDeleting] = useState(false);
    const [text, setText] = useState('');
    const [delta, setDelta] = useState(300 - Math.random() * 100);

    const tick = useCallback(() => {
        const toRotate = [ "Software Developer", "DevOps Engineer", "AWS Certified Cloud Practitioner"];
        const i = loopNum % toRotate.length;
        const fullText = toRotate[i];
        const updatedText = isDeleting
            ? fullText.substring(0, text.length - 1)
            : fullText.substring(0, text.length + 1);

        setText(updatedText);

        if (isDeleting) {
            setDelta(prevDelta => prevDelta / 2);
        }

        if (!isDeleting && updatedText === fullText) {
            setIsDeleting(true);
            setDelta(2000); // Pause before deleting
        } else if (isDeleting && updatedText === '') {
            setIsDeleting(false);
            setLoopNum(prevLoopNum => prevLoopNum + 1);
            setDelta(500); // Pause before typing next word
        }
    }, [text, isDeleting, loopNum]);

    useEffect(() => {
        const ticker = setInterval(() => {
            tick();
        }, delta);

        return () => clearInterval(ticker);
    }, [text, tick, delta]);

    return (
        <section className="banner" id="home">
            <Container>
                <Row className="align-items-center">
                    <Col xs={12} md={6} xl={7}>
                      <TrackVisibility>
                         {({ isVisible }) =>
                            <div className={isVisible ? "animate__animated animate__fadeIn" : ""}>
                                <span className="tagline">Welcome To My Portfolio</span>
                                <h1>
                                {`Hi my name is Dennis and I am a `}
                                <span className="wrap">{text}</span>
                                </h1>

                                {/* Let's Connect Button */}
                                <button onClick={() => console.log('connect')}>
                                Let's Connect <ArrowRightCircle size={25} />
                                </button>
                            </div>
                        }
                        </TrackVisibility>
                    </Col>
                    <Col xs={12} md={6} xl={5}>
                        <img src={headerImg} alt="Header Img" />
                    </Col>
                </Row>
            </Container>
        </section>
    );
};